import { useContext } from 'react'

import { ContactContext } from '../../providers'

export const useContactProvider = () => {
  const context = useContext(ContactContext)
  if (!context) {
    throw new Error(
      `Contact compound components cannot be rendered outside the Contact component`
    )
  }
  return context
}
